// extracted by mini-css-extract-plugin
export default {"row":"Artist_row__D4jI4","header":"Artist_header__+W8qh","cover":"Artist_cover__RGMhQ"};